/* eslint-disable max-len */
import { useLocaleField } from '@/hooks/useLocaleField';
import { Box, Flex, Text } from '@chakra-ui/react';
import cn from 'classnames';
import Link from 'next/link';
import { FC } from 'react';
import { BsArrowRightShort } from 'react-icons/bs';
import { SimpleCarousel } from '../SimpleCarousel';
import styles from './RoomListItem.module.css';
import { RoomListItemProps } from './RoomListItem.props';

const RoomListItem: FC<RoomListItemProps> = ({ room }) => {

  const { getLocaleField } = useLocaleField();

  return (
    <Box mb={{ base: '70px', md: '170px' }}>
      <Flex flexDirection={{ base: 'column', md: 'row' }}>
        <Box flex={1} position="relative">
          <Box className={cn(styles.carousel)}>
            <SimpleCarousel images={room.images} />
          </Box>
        </Box>
        <Box className={styles.textWrapper} flex="1" p={{ base: '15px 15px 25px', md: '60px 30px' }}>
          <Text color="blackAlpha.800" fontFamily="heading" mb="20px" fontWeight="bold" fontSize="2rem">
            {getLocaleField(room.name)}
          </Text>
          {room?.price?.show_price&&
            <Box color="purple.700" fontSize="medium">
              <Box as="span" fontSize="xl" fontWeight="semibold">{getLocaleField(room?.price.price)}</Box>
            </Box>
          }
          <Box fontSize="1rem" my="20px">
            <Text>{getLocaleField(room.shortDescription)}</Text>
          </Box>
          {/* <Flex flexWrap="wrap">
          {room.occupancy && <RoomFeature icon="group" name={room.occupancy} />}
          {room?.room_features?.map((feature) => {
            if (feature.show_in_list) {
              return <RoomFeature key={feature.id} icon={feature.icon} name={feature.name} />;
            }

            return null;
          })}
        </Flex> */}
          <Box textAlign="center" mt={{ md: '30px' }}>
            <Link href={`/rooms/${room.slug?.current}`}>
              <Text
                borderColor="blue.700"
                color="blue.700"
                borderBottomWidth={1}
                textTransform="uppercase"
                display="inline-block"
                py={2}
                flexDirection="row"
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <span style={{ marginRight: 10 }}>View Details</span>
                  <BsArrowRightShort />
                </span>
              </Text>
            </Link>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export { RoomListItem };
